/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { sigintListSensors } from "../funcs/sigintListSensors.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListSigintSensorsRequest,
  ListSigintSensorsResponse,
  ListSigintSensorsSecurity,
} from "../models/operations/listsigintsensors.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SigintSensorsQueryData = ListSigintSensorsResponse;

export type SigintSensorsInfiniteQueryData = PageIterator<
  ListSigintSensorsResponse,
  { cursor: string }
>;

export type SigintSensorsPageParams = PageIterator<
  ListSigintSensorsResponse,
  { cursor: string }
>["~next"];

export function prefetchSigintSensors(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSigintSensorsRequest | undefined,
  security?: ListSigintSensorsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSigintSensorsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSigintSensorsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSigintSensorsRequest | undefined,
  security?: ListSigintSensorsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSigintSensorsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SigintSensorsPageParams,
    getNextPageParam: (previousPage: SigintSensorsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSigintSensorsQuery(
  client$: GramCore,
  request?: ListSigintSensorsRequest | undefined,
  security?: ListSigintSensorsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SigintSensorsQueryData>;
} {
  return {
    queryKey: queryKeySigintSensors({
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function sigintSensorsQueryFn(
      ctx,
    ): Promise<SigintSensorsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(sigintListSensors(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSigintSensorsInfiniteQuery(
  client$: GramCore,
  request?: ListSigintSensorsRequest | undefined,
  security?: ListSigintSensorsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SigintSensorsPageParams>,
  ) => Promise<SigintSensorsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySigintSensorsInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function sigintSensorsQuery(
      ctx,
    ): Promise<SigintSensorsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(sigintListSensors(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(sigintListSensors(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySigintSensors(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "sigint", "listSensors", parameters];
}

export function queryKeySigintSensorsInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "sigint", "listSensors", "infinite", parameters];
}
